const REBUY_KEY = '5877e4997d0575f1a0a998202eca9b9e35a21900';
export const getRebuyUpsells = (callback, id, shopify_product_ids='') => {
  fetch(`https://rebuyengine.com/api/v1/custom/id/${id}?shop=pair-piercing.myshopify.com&key=${REBUY_KEY}&metafields=yes&variant_metafields=yes&limit=10&shopify_product_ids=${shopify_product_ids}`)
    .then((blob) => blob.json())
    .then((response) => {
      callback(response.data)
    })
}